var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1927 0.315312L5.29404 11.3997L1.80729 7.85388C1.39368 7.43346 0.723627 7.43346 0.310015 7.85388C-0.103338 8.27456 -0.103338 8.95606 0.310015 9.37674L4.5454 13.6845C4.75246 13.8951 5.02286 14 5.29404 14C5.56521 14 5.83561 13.8951 6.04268 13.6845L17.69 1.83817C18.1033 1.41749 18.1033 0.735991 17.69 0.315312C17.2764 -0.105104 16.6063 -0.105104 16.1927 0.315312Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.bda98ba511f4305b9b163cd6b3d40953.svg";
export { ForwardRef as ReactComponent };